/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class AccountAPIFormDialog extends NoboxEntityDialog<AccountRow, any> {
        protected getFormKey() { return AccountAPIForm.formKey; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getService() { return AccountService.baseUrl; }
        protected getDeletePermission() { return AccountRow.deletePermission; }
        protected getInsertPermission() { return AccountRow.insertPermission; }
        protected getUpdatePermission() { return AccountRow.updatePermission; }

        protected form = new AccountAPIForm(this.idPrefix);
        public setTemplate = (account: AccountRow) => { };

        private btnMessageCount: number = 0;
        private btnActionCount: number = 0;
        constructor(container?: JQuery) {
            super(container);
            this.form.AccountId.change(() => {
                var val = this.form.AccountId.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    AccountService.Retrieve({ EntityId: val }, (res) => {
                        var item = res.Entity;
                        this.showSMTP(item.IsSMTP, item.Channel);
                        Serenity.EditorUtils.setValue(this.form.KeyApi, item.KeyApi);
                        Serenity.EditorUtils.setValue(this.form.FromApi, item.FromApi);
                        Serenity.EditorUtils.setValue(this.form.EndpointApi, item.EndpointApi);
                        Serenity.EditorUtils.setValue(this.form.BaseUrlApi, item.BaseUrlApi);
                        Serenity.EditorUtils.setValue(this.form.Provider, item.Provider);
                        Serenity.EditorUtils.setValue(this.form.Password, item.Password);
                        Serenity.EditorUtils.setValue(this.form.Username, item.Username);
                        Serenity.EditorUtils.setValue(this.form.From, item.From);
                        Serenity.EditorUtils.setValue(this.form.UseSSL, item.UseSSL);
                        Serenity.EditorUtils.setValue(this.form.Port, item.Port);
                        Serenity.EditorUtils.setValue(this.form.Host, item.Host);
                        Serenity.EditorUtils.setValue(this.form.IsSMTP, item.IsSMTP);
                        Serenity.EditorUtils.setValue(this.form.ApiExtra, item.ApiExtra);
                        Serenity.EditorUtils.setValue(this.form.ApiSecret, item.ApiSecret);
                        Serenity.EditorUtils.setValue(this.form.ApiClient, item.ApiClient);
                        Serenity.EditorUtils.setValue(this.form.ApiId, item.ApiId);
                    });
                } else {
                    this.showSMTP("", 1);
                    Serenity.EditorUtils.setValue(this.form.KeyApi, null);
                    Serenity.EditorUtils.setValue(this.form.FromApi, null);
                    Serenity.EditorUtils.setValue(this.form.EndpointApi, null);
                    Serenity.EditorUtils.setValue(this.form.BaseUrlApi, null);
                    Serenity.EditorUtils.setValue(this.form.Provider, null);
                    Serenity.EditorUtils.setValue(this.form.Password, null);
                    Serenity.EditorUtils.setValue(this.form.Username, null);
                    Serenity.EditorUtils.setValue(this.form.From, null);
                    Serenity.EditorUtils.setValue(this.form.UseSSL, null);
                    Serenity.EditorUtils.setValue(this.form.Port, null);
                    Serenity.EditorUtils.setValue(this.form.Host, null);
                    Serenity.EditorUtils.setValue(this.form.IsSMTP, null);
                    Serenity.EditorUtils.setValue(this.form.ApiExtra, null);
                    Serenity.EditorUtils.setValue(this.form.ApiSecret, null);
                    Serenity.EditorUtils.setValue(this.form.ApiClient, null);
                    Serenity.EditorUtils.setValue(this.form.ApiId, null);
                }
            });
        }

        protected showSMTP(issmtp, chid) {
            $(".email-btn .button-outer .button-inner").text('Test ' + issmtp)
            this.element.find(".email-btn").attr("title", "Test " + issmtp);
            if (chid == "19") {
                this.element.find(".email-btn").show();
            } else {
                this.element.find(".email-btn").hide();
            }
            var $form = this.form;
            //SMTP
            var value = issmtp == "SMTP" && chid == "19" ? true : false;
            $form.Host.getGridField().toggle(value);
            $form.Port.getGridField().toggle(value);
            $form.UseSSL.getGridField().toggle(value);
            $form.From.getGridField().toggle(value);
            $form.Username.getGridField().toggle(value);
            $form.Password.getGridField().toggle(value);

            //API
            value = issmtp == "API" && chid == "19" ? true : false;
            $form.EndpointApi.getGridField().toggle(value);
            $form.Provider.getGridField().toggle(value);
            $form.BaseUrlApi.getGridField().toggle(value);
            $form.KeyApi.getGridField().toggle(value);
            $form.FromApi.getGridField().toggle(value);
            if (chid == "19") {
                $form.ApiId.getGridField().toggle(false);
                $form.ApiClient.getGridField().toggle(false);
                $form.ApiSecret.getGridField().toggle(false);
                $form.ApiExtra.getGridField().toggle(false);
                $form.IsSMTP.getGridField().toggle(true);
            } else {
                $form.ApiId.getGridField().toggle(true);
                $form.ApiClient.getGridField().toggle(true);
                $form.ApiSecret.getGridField().toggle(true);
                $form.ApiExtra.getGridField().toggle(true);
                $form.IsSMTP.getGridField().toggle(false);
            }
        }

        protected updateInterface() {
            super.updateInterface();
        }

        protected getDialogTitle() {
            return "Import Setting AI Chatbot";
        }

        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Import Setting",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.setTemplate(this.getSaveEntity());
                        this.dialogClose();
                    }
                }
            });
            return buttons;
        }
    }
}